<ng-container *ngIf="processView$ | async as processView">
	<stages-feedback-widget *ngIf="processView.feedback?.systemType === 'CREATE_TICKET'"></stages-feedback-widget>

	<stages-feedback-link-widget
		*ngIf="processView.feedback?.systemType === 'CREATE_TICKET_LINK'"
	></stages-feedback-link-widget>
</ng-container>
